import React from 'react';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  createStyles,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Theme,
  Typography
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import { useTranslation } from 'react-i18next';
import utils from '../../services/utils.service';
import { useRevolusendApi } from '../../context';
import notFoundImg from '../../assets/img/not-found.svg';
import DetailsIcon from '@material-ui/icons/Info';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { BatchListItem } from '../../services/types/revolusend/batchListItem.type';
import AddIcon from '@material-ui/icons/Add'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    img: {
      width: 400,
      maxWidth: '100%',
      display: 'block',
      margin: '0 auto',
    },
  })
);

const Row = (props: { batch: BatchListItem }) => {
  const { batch } = props;
  const history = useHistory();
  const { t } = useTranslation(['revolusendBatches', 'revolusendDeliveryMethod']);

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton size='small' onClick={() => { history.push('/revolusend/batches/' + batch.batch.id) }}>
            <DetailsIcon />
          </IconButton>
        </TableCell>
        <TableCell>
          {t(`revolusendDeliveryMethod:${batch.transaction_type.code}`)}
        </TableCell>
        <TableCell>
          {moment(batch.batch.created).format('DD-MM-YYYY HH:mm:ss')}
        </TableCell>
        <TableCell>
          <Chip label={batch.batch.processed ? moment(batch.batch.processed).format('DD-MM-YYYY HH:mm:ss') : t('NOT_YET')} color={batch.batch.processed ? 'primary' : 'default'} />
        </TableCell>
        <TableCell>
          {batch.batch.transaction_count}
        </TableCell>
        <TableCell>
          {batch.batch.success_transaction_count}
        </TableCell>
        <TableCell>
          {batch.batch.failed_transaction_count}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const Batches = () => {
  const { t } = useTranslation(['revolusendBatches', 'revolusendDeliveryMethod']);
  const api = useRevolusendApi();
  const [count, setCount] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [batches, setBatches] = React.useState<BatchListItem[]>([]);

  const [page, setPage] = React.useState(0);

  const limit = 15;

  const classes = useStyles();

  const history = useHistory();

  React.useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        setLoading(true);
        const { batches, count } = await api.listRevolusendBatches({}, limit, page * limit, 'desc');
        if (isMounted) {
          setBatches(batches);
          setCount(count);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    }
  }, [page]);

  const handlePageChangeCallback = React.useCallback((event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  }, []);

  return (
    <Grid container spacing={2} style={{ marginTop: 15 }}>
      <Grid item container justify='flex-end' xs={12}>
        <Button variant='outlined' color='secondary' startIcon={<AddIcon />} onClick={() => { history.push('/revolusend/newbatch') }}>
          {t('ADD')}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Grid container>
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>{t('DELIVERY_METHOD')}</TableCell>
                      <TableCell>{t('CREATED')}</TableCell>
                      <TableCell>{t('PROCESSED')}</TableCell>
                      <TableCell>{t('TOTAL_TRANSACTIONS')}</TableCell>
                      <TableCell>{t('SUCCESS_TRANSACTIONS')}</TableCell>
                      <TableCell>{t('ERROR_TRANSACTIONS')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {batches.map(b =>
                      <Row
                        batch={b}
                        key={b.batch.id}
                      />)}
                    {loading && batches.length === 0 &&
                      <TableCell colSpan={7}>
                        <Box padding={2}>
                          <Grid container justify='center' item xs={12}>
                            <CircularProgress />
                          </Grid>
                        </Box>
                      </TableCell>
                    }
                    {!loading && batches.length === 0 &&
                      <TableCell colSpan={7}>
                        <Box padding={2}>
                          <Typography align='center' variant='h5'>{t('NO_DATA')}</Typography>
                          <img className={classes.img} src={notFoundImg} />
                        </Box>
                      </TableCell>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component='div'
                rowsPerPageOptions={[limit]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onPageChange={handlePageChangeCallback}
                onChangePage={handlePageChangeCallback}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid >
  )
}
